<template>
  <b-modal id="discover-modal" :static="true" hide-footer centered @show="showModal">
    <template #modal-header>
      <CloseButton modal-name="discover-modal" />
    </template>
    <DiscoverDesktop ref="discoverDesktop" class="d-none d-xl-flex" />
    <DiscoverMobile class="d-block d-xl-none" />
  </b-modal>
</template>
<script>
import DiscoverDesktop from '@/components/Discover/Desktop';
import DiscoverMobile from '@/components/Discover/Mobile';
import CloseButton from 'UI/CloseButton';

export default {
  name: 'HeaderApp',
  components: {
    DiscoverDesktop,
    DiscoverMobile,
    CloseButton
  },
  methods: {
    showModal() {
      this.$refs.discoverDesktop.setInitialBackground();
    }
  }
};
</script>
